































import { Prop, Component, Vue } from 'vue-property-decorator'
import { TriggeredReferral } from '@/api/model/triggered-referral'
import { TriggeredReferralAPI } from '@/api/backend-client'

@Component
export default class TriggeredReferralDetail extends Vue {
    @Prop({ required: true }) readonly triggeredReferralId!: string
    triggeredReferral: TriggeredReferral = null
    loading: boolean = false

    async mounted() {
        this.loading = true
        await this.loadTriggeredReferral()
        this.loading = false
    }

    async loadTriggeredReferral(): Promise<void> {
        this.triggeredReferral = await TriggeredReferralAPI.get(this.triggeredReferralId, true)
    }

    async goBackToListener(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_virtual_colleague_triggered_referral',
        })
    }
}
